import { render, staticRenderFns } from "./openFreame.vue?vue&type=template&id=1a392a44&scoped=true"
import script from "./openFreame.vue?vue&type=script&lang=js"
export * from "./openFreame.vue?vue&type=script&lang=js"
import style0 from "./openFreame.vue?vue&type=style&index=0&id=1a392a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a392a44",
  null
  
)

export default component.exports